<script setup>
    import { ChartPieIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <ChartPieIcon />
</template>
